import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://geekid.com.cn'

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 从localStorage获取token
    const token = localStorage.getItem('fanqianai_admin_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // 添加缓存控制头，确保获取最新数据
    config.headers['Cache-Control'] = 'no-cache'
    config.headers['Pragma'] = 'no-cache'

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    if (error.response) {
      // 处理HTTP错误状态码
      switch (error.response.status) {
        case 401:
          // 未授权，清除token并跳转到登录页
          console.warn('Token过期或无效，跳转到登录页')
          localStorage.removeItem('fanqianai_admin_token')
          localStorage.removeItem('fanqianai_admin_user')
          // 避免在已经在登录页时重复跳转
          if (window.location.pathname !== '/login') {
            window.location.href = '/login'
          }
          break
        case 403:
          console.error('权限不足')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          console.error('请求失败:', error.response.data?.message || error.message)
      }
      return Promise.reject(error.response.data || error.response)
    } else if (error.request) {
      console.error('网络错误，请检查网络连接')
      return Promise.reject({ message: '网络错误，请检查网络连接' })
    } else {
      console.error('请求配置错误:', error.message)
      return Promise.reject({ message: error.message })
    }
  }
)

const state = {
  loading: false,
  error: null
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  // 通用API请求方法
  async request({ commit }, { url, method = 'GET', data = null, params = null }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const config = {
        method,
        url,
        ...(data && { data }),
        ...(params && { params })
      }
      
      const response = await apiClient(config)
      commit('SET_LOADING', false)
      return response
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error)
      throw error
    }
  },

  // GET请求
  async get({ dispatch }, { url, params }) {
    return dispatch('request', { url, method: 'GET', params })
  },

  // POST请求
  async post({ dispatch }, { url, data }) {
    return dispatch('request', { url, method: 'POST', data })
  },

  // PUT请求
  async put({ dispatch }, { url, data }) {
    return dispatch('request', { url, method: 'PUT', data })
  },

  // DELETE请求
  async delete({ dispatch }, { url }) {
    return dispatch('request', { url, method: 'DELETE' })
  }
}

const getters = {
  isLoading: state => state.loading,
  error: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
